import { gql } from 'apollo-angular';

export const GET_OFFER_ATTACHMENT_DOWNLOAD_URL = gql`
  query getNewAttachmentDownloadUrl($fileId: Long!, $offerId: Long!) {
    downloadOfferAttachment(input: { fileId: $fileId, offerId: $offerId }) {
      url
    }
  }
`;
